import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export default function BranchWrapper(props: any) {
  const router = useRouter();
  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });

  useEffect(() => {
    if (currentBranch) {
      router.push("/");
    }
  }, []);

  return currentBranch ? null : props.children;
}
